import {useTranslation} from 'lib/i18n';
import {useMemo} from 'react';

export default function useIncomeFrequencyOptions() {
  const {t} = useTranslation();

  return useMemo(() => t('inputsTranslation:borrower info.income frequency options', {returnObjects: true}), [t]);
}
